import React, { useState, useEffect, useRef } from "react";
import { useInput } from "./Context";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import TopNavbar from "./Navbar/Navbar";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
  ListGroup,
  Modal,
  Spinner,
} from "react-bootstrap";
import "./EmployeeSearch.css";

export default function EmployeeSearch() {
  const { inputValue, setInputValue } = useInput();

  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [isRegionFetch, setIsRegionFetch] = useState(false);
  const [showEmployeeBox, setShowEmployeeBox] = useState(false);

  const suggestionsRef = useRef(null);
  const [filterAreaOffice, setFilterAreaOffice] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [userData, setUserData] = useState({
    employeeName: "",
    areaoffice: "",
    mobile: "",
    email: "",
    address: "",
  });

  const navigate = useNavigate();

  const areaOfficeList = [
    "BIHAR","PATNA","DELHI","HARYANA","UTTAR PRADESH","GUJARAT","HYDERABAD","RANCHI",
    "TAMIL NADU","BANGALORE","TELANGANA","SOUTH","KARNATAKA","COCHIN","KERALA",
    "MADHYA PRADESH","MAHARASTHA","MUMBAI","ASSAM","NE","TRIPURA","ODISHA","JALANDHAR",
    "JODHPUR","RAJASTHAN","TAMILNADU","CHENNAI","ANDHRA PRADESH","LUCKNOW(UP)",
    "UTTARAKHAND","WEST BENGAL","KOLKATA (WEST BENGAL)","MAHARASHTRA",
  ];

  const fetchEmployeesByRegion = async (region) => {
    try {
      setLoading(true);
      setIsRegionFetch(true);
      const response = await axios.get(
        "https://api.assetview.warrantyindia.com/api/employees/search",
        { params: { areaoffice: region } }
      );
      setSuggestions(response.data || []);
      setShowEmployeeBox(true);
      setShowSuggestions(true);
      setInputValue(`📍 ${region} (${response.data.length} employees)`);
    } catch (error) {
      console.error("Error fetching employees by region:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filterAreaOffice) {
      fetchEmployeesByRegion(filterAreaOffice);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
      setShowEmployeeBox(false);
      setIsRegionFetch(false);
      if (!inputValue.includes('employees') && !inputValue.includes('📍')) {
        setInputValue('');
      }
    }
  }, [filterAreaOffice]);

  useEffect(() => {
    if (filterAreaOffice && (inputValue.trim() === '' || inputValue.includes('employees') || inputValue.includes('📍'))) {
      return;
    }
    
    if (inputValue.trim() === '') {
      return;
    }

    const fetchEmployees = async () => {
      try {
        setLoading(true);
        setIsRegionFetch(false);
        const response = await axios.get(
          "https://api.assetview.warrantyindia.com/api/employees/search",
          { params: { q: inputValue.trim(), areaoffice: filterAreaOffice || undefined } }
        );
        setSuggestions(response.data || []);
        setShowEmployeeBox(true);
        setShowSuggestions(true);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      } finally {
        setLoading(false);
      }
    };

    const debounceTimer = setTimeout(fetchEmployees, 300);
    return () => clearTimeout(debounceTimer);
  }, [inputValue, filterAreaOffice]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSelectedIndex(-1);
    
    if (filterAreaOffice && value.trim() !== '' && !value.includes('employees') && !value.includes('📍')) {
      setFilterAreaOffice('');
      setIsRegionFetch(false);
    }
  };

  const handleFilterChange = (e) => {
    const selectedRegion = e.target.value;
    setFilterAreaOffice(selectedRegion);
    setSelectedIndex(-1);
    if (selectedRegion) {
      setInputValue('');
      setShowEmployeeBox(true);
    }
  };

  const handleClearFilter = () => {
    setFilterAreaOffice("");
    setInputValue("");
    setSuggestions([]);
    setShowSuggestions(false);
    setIsRegionFetch(false);
    setShowEmployeeBox(false);
  };

  const handleCloseBox = () => {
    setShowEmployeeBox(false);
    setShowSuggestions(false);
    if (!filterAreaOffice) {
      setSuggestions([]);
    }
  };

  const handleKeyDown = (e) => {
    if (!showSuggestions || suggestions.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setSelectedIndex((prev) =>
        prev < suggestions.length - 1 ? prev + 1 : prev
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
    } else if (e.key === "Enter") {
      if (selectedIndex >= 0 && selectedIndex < suggestions.length) {
        e.preventDefault();
        handleSuggestionClick(suggestions[selectedIndex]);
      }
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setInputValue(suggestion.employeeName);
    sessionStorage.setItem("name", suggestion.employeeName);
    setShowSuggestions(false);
    setShowEmployeeBox(false);
    if (filterAreaOffice) {
      setFilterAreaOffice('');
      setIsRegionFetch(false);
    }
    navigate("/Search");
  };

  const handleAddUserClick = () => setShowModal(true);
  
  const handleModalClose = () => {
    setShowModal(false);
    setUserData({
      employeeName: "",
      areaoffice: "",
      mobile: "",
      email: "",
      address: "",
    });
  };

  const handleUserInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        "https://api.assetview.warrantyindia.com/api/employees/add",
        userData
      );
      setShowModal(false);
      if (filterAreaOffice) {
        await fetchEmployeesByRegion(filterAreaOffice);
      }
      setUserData({
        employeeName: "",
        areaoffice: "",
        mobile: "",
        email: "",
        address: "",
      });
      alert("User added successfully!");
    } catch (error) {
      console.error("Error adding user:", error);
      alert("Error adding user. Please try again.");
    }
  };

  return (
    <>
      <TopNavbar />

      <div className="employees-page">
        <Container fluid className="py-4">
          <Row className="justify-content-center">
            <Col xl={10} lg={11}>
              <Card className="emp-card shadow-lg border-0">
                <Card.Header className="emp-card-header py-4">
                  <div className="d-flex align-items-center gap-3 flex-wrap justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                      <div className="header-icon">
                        <i className="fa-solid fa-magnifying-glass"></i>
                      </div>
                      <div>
                        <h1 className="page-title mb-1">Employee Search</h1>
                        <p className="page-subtitle mb-0">
                          Find employees quickly. Filter by Area Office. Add new entries.
                        </p>
                      </div>
                    </div>

                    <div className="d-flex gap-2">
                      <Button
                        variant="outline-light"
                        className="btn-ghost"
                        onClick={handleAddUserClick}
                      >
                        <i className="fa-solid fa-user-plus me-2"></i>Add User
                      </Button>
                    </div>
                  </div>
                </Card.Header>

                <Card.Body className="p-4">
                  {/* Main Content - Flex Layout */}
                  <div className="main-content-wrapper">
                    {/* Left Side - Search and Filters */}
                    <div className="left-content">
                      <div className="search-wrap">
                        <InputGroup className="search-input-group">
                          <span className="input-group-text search-leading-icon">
                            <i className="fa-regular fa-id-badge"></i>
                          </span>
                          <Form.Control
                            placeholder={
                              filterAreaOffice 
                                ? `Showing employees in ${filterAreaOffice}...` 
                                : "Search employee by name..."
                            }
                            value={inputValue}
                            onChange={handleInputChange}
                            onFocus={() => {
                              if (filterAreaOffice && !showSuggestions) {
                                fetchEmployeesByRegion(filterAreaOffice);
                              }
                            }}
                            onKeyDown={handleKeyDown}
                            className="form-control-professional"
                          />
                          <Button 
                            variant="primary" 
                            className="btn-search" 
                            onClick={() => {
                              if (filterAreaOffice) {
                                fetchEmployeesByRegion(filterAreaOffice);
                              } else if (inputValue.trim()) {
                                setShowEmployeeBox(true);
                                setShowSuggestions(true);
                              }
                            }}
                          >
                            {loading ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              <i className="fa-solid fa-magnifying-glass"></i>
                            )}
                          </Button>
                        </InputGroup>
                      </div>

                      <div className="filters-row">
                        <Form.Select
                          value={filterAreaOffice}
                          onChange={handleFilterChange}
                          className="form-control-professional"
                        >
                          <option value="">🌐 All Regions</option>
                          {areaOfficeList.map((area) => (
                            <option key={area} value={area}>
                              {area}
                            </option>
                          ))}
                        </Form.Select>
                        <Button
                          variant="outline-secondary"
                          className="btn-clear"
                          onClick={handleClearFilter}
                        >
                          <i className="fa-solid fa-times me-1"></i> Clear
                        </Button>
                      </div>
                    </div>

                    {/* Right Side - Employee Box */}
                    {showEmployeeBox && (
                      <div className="employee-box-wrapper">
                        <div className="employee-box">
                          <div className="employee-box-header">
                            <div className="box-title">
                              <i className="fa-solid fa-users"></i>
                              {isRegionFetch && filterAreaOffice ? (
                                <>
                                  {filterAreaOffice}
                                  <span className="badge-count">{suggestions.length}</span>
                                </>
                              ) : (
                                <>
                                  Employees
                                  <span className="badge-count">{suggestions.length}</span>
                                </>
                              )}
                            </div>
                            <button 
                              className="box-close-btn"
                              onClick={handleCloseBox}
                            >
                              <i className="fa-solid fa-xmark"></i>
                            </button>
                          </div>

                          <div className="employee-box-body">
                            {loading ? (
                              <div className="box-loading">
                                <Spinner animation="border" size="sm" className="me-2" />
                                Loading...
                              </div>
                            ) : suggestions.length > 0 ? (
                              <ListGroup className="employee-list">
                                {suggestions.map((s, idx) => (
                                  <ListGroup.Item
                                    key={`${s.employeeName}-${idx}`}
                                    action
                                    onClick={() => handleSuggestionClick(s)}
                                    className={`employee-list-item ${
                                      selectedIndex === idx ? "active" : ""
                                    }`}
                                  >
                                    <span className="employee-index">#{idx + 1}</span>
                                    <span className="employee-name">
                                      {s.employeeName}
                                    </span>
                                    {s.areaoffice && (
                                      <span className="employee-badge">
                                        {s.areaoffice}
                                      </span>
                                    )}
                                  </ListGroup.Item>
                                ))}
                              </ListGroup>
                            ) : (
                              <div className="box-empty">
                                <i className="fa-regular fa-folder-open me-2"></i>
                                No employees found
                              </div>
                            )}
                          </div>

                          <div className="employee-box-footer">
                            <i className="fa-regular fa-circle-check me-1"></i>
                            Total: {suggestions.length} employee{suggestions.length !== 1 ? 's' : ''}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add User Modal */}
      <Modal show={showModal} onHide={handleModalClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fa-solid fa-user-plus me-2"></i>
            Add New User
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit} className="modal-form">
            <Form.Group className="mb-3">
              <Form.Label>Employee Name <span className="text-danger">*</span></Form.Label>
              <Form.Control
                name="employeeName"
                value={userData.employeeName}
                onChange={handleUserInputChange}
                required
                className="form-control-professional"
                placeholder="Enter employee name"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Area Office <span className="text-danger">*</span></Form.Label>
              <Form.Select
                name="areaoffice"
                value={userData.areaoffice}
                onChange={handleUserInputChange}
                required
                className="form-control-professional"
              >
                <option value="">Choose Area Office</option>
                {areaOfficeList.map((area) => (
                  <option key={area} value={area}>
                    {area}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Mobile <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    name="mobile"
                    value={userData.mobile}
                    onChange={handleUserInputChange}
                    required
                    className="form-control-professional"
                    placeholder="Enter mobile number"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={userData.email}
                    onChange={handleUserInputChange}
                    required
                    className="form-control-professional"
                    placeholder="Enter email"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group>
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="address"
                value={userData.address}
                onChange={handleUserInputChange}
                className="form-control-professional"
                placeholder="Enter address"
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button variant="outline-secondary" onClick={handleModalClose}>
                Cancel
              </Button>
              <Button type="submit" className="btn-save">
                <i className="fa-solid fa-save me-2"></i>Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}